//  need dimensions
// =======================
// 1) TYPE KIT MOTORISATION
// =======================

import formInputsTypes from '../simulatorConstant';

// ==================================
// 5) RAIL PLAFOND : MARQUE (Somfy / Sommer)
// ==================================

export const kitRailMarque = {
	id: 'PG-KM-RAIL-MAR',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'kitRailMarque',
	className: 'col-12',
	label: 'Marque',
	nextStepData: false,
	options: [
		{
			id: 'PG-KM-RAIL-MAR-SOMFY',
			label: 'Somfy',
			value: 'Somfy',
			nextStep: false,
			description:
				'- Marque : Somfy\n\n' +
				'Description du kit :\n' +
				'- Rail de guidage plafond (chaîne ou courroie) avec chariot de traction\n' +
				'- Bras de liaison porte / chariot et accessoires de fixation complets\n' +
				'- Centrale de commande intégrée avec récepteur radio\n' +
				'- Télécommande(s) radio pour ouverture et fermeture à distance\n' +
				'- Système de déverrouillage manuel de secours (coupure de courant)\n' +
				'- Fins de course automatiques et détection d’obstacles pour la sécurité\n' +
				'- Notice de pose et de réglage fournie',
		},
		{
			id: 'PG-KM-RAIL-MAR-SOMMER',
			label: 'Sommer',
			value: 'Sommer',
			nextStep: false,
			description:
				'- Marque : Sommer\n\n' +
				'Description du kit :\n' +
				'- Rail de guidage plafond (chaîne ou courroie) avec chariot de traction\n' +
				'- Bras de liaison porte / chariot et accessoires de fixation complets\n' +
				'- Centrale de commande intégrée avec récepteur radio\n' +
				'- Télécommande(s) radio pour ouverture et fermeture à distance\n' +
				'- Système de déverrouillage manuel de secours (coupure de courant)\n' +
				'- Fins de course automatiques et détection d’obstacles pour la sécurité\n' +
				'- Notice de pose et de réglage fournie',
		},

	],
};

// ==================================
// 4) TUBULAIRE : SECOURS / MANIVELLE
// ==================================

export const kitTubulaireSecours = {
	id: 'PG-KM-TUB-SECOURS',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'kitTubulaireSecours',
	className: 'col-12',
	label: 'Manivelle de secours',
	nextStepData: false,
	options: [
		{
			id: 'PG-KM-TUB-SECOURS-OUI',
			label: 'Avec manivelle de secours',
			value: 'Avec secours',
			nextStep: false, // ou next step (ex: dimensions / résumé)
			description:
				'- Ajout d’un manivelle de secours permettant la manœuvre en cas de coupure de courant.\n'
		},
		{
			id: 'PG-KM-TUB-SECOURS-NON',
			label: 'Sans manivelle de secours',
			value: 'Sans secours',
			nextStep: false, // ou next step (ex: dimensions / résumé)

		},
	],
};

// Longueur d’axe (si “avec axe”)
export const kitTubulaireLongueurAxe = {
	id: 'PG-KM-TUB-AXE-L',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'kitTubulaireLongueurAxe',
	className: 'col-6',
	label: 'Longueur de l’axe (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: kitTubulaireSecours,
	validation: (v) => v > 0,
};

// ==================================
// 3) TUBULAIRE : AXE ENROULEMENT ?
// ==================================

export const kitTubulaireAxeEnroulement = {
	id: 'PG-KM-TUB-AXE',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'kitTubulaireAxeEnroulement',
	className: 'col-12',
	label: 'Axe d’enroulement',
	nextStepData: false,
	options: [
		{
			id: 'PG-KM-TUB-AXE-OUI',
			label: 'Avec axe d’enroulement',
			value: 'Avec axe',
			nextStep: kitTubulaireLongueurAxe,
			description: "- Avec un axe d'enroulement",
		},
		{
			id: 'PG-KM-TUB-AXE-NON',
			label: 'Sans axe d’enroulement',
			value: 'Sans axe',
			nextStep: kitTubulaireSecours,
			description: "- Sans un axe d'enroulement",
		},
	],
};
// Puissance - Rail plafond
export const kitMotorisationPuissanceRail = {
	id: 'PG-KM-PWR-RAIL',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'kitMotorisationPuissance',
	className: 'col-6',
	label: 'Puissance du moteur (Nm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: kitRailMarque,
	validation: (v) => v > 0,
};

// ==================================
// 2) PUISSANCE (TUBULAIRE / RAIL)
// ==================================

// Puissance - Tubulaire
export const kitMotorisationPuissanceTubulaire = {
	id: 'PG-KM-PWR-TUB',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'kitMotorisationPuissance',
	className: 'col-6',
	label: 'Puissance du moteur (Nm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: kitTubulaireAxeEnroulement,
	validation: (v) => v > 0,
};

export const kitMotorisationType = {
	id: 'PG-KM-TYPE',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'kitMotorisationType',
	className: 'col-12',
	label: 'Type de kit motorisation',
	nextStepData: false,

	fetchData: (currentFormValue, fnSuccess) => {
		// doorType == enroulable / basculante / sectionnelle
		const doorType =
			currentFormValue?.Type?.value ||
			currentFormValue?.values?.Type?.value ||
			currentFormValue?.typePorte?.value ||
			currentFormValue?.typePorte?.label;

		const makeDesc = (type) => {
			if (type === 'tubulaire') {
				return (
					`Fourniture d’un kit de motorisation tubulaire pour porte de garage ${doorType || ''
					}.\n` +
					`La motorisation est intégrée dans l’axe d’enroulement et assure une montée et une descente fluides du tablier, garantissant un fonctionnement fiable, discret et sécurisé.`
				);
			}

			// rail plafond
			return (
				`Fourniture d’un kit de motorisation à rail pour porte de garage ${doorType || ''
				}.\n` +
				`La motorisation fonctionne par rail plafond et assure une ouverture et une fermeture fluides de la porte, garantissant un fonctionnement fiable et sécurisé.`
			);
		};

		const options = [
			{
				id: 'PG-KM-TYPE-TUB',
				label: 'Tubulaire',
				value: 'Tubulaire',
				nextStep: kitMotorisationPuissanceTubulaire,
				description: makeDesc('tubulaire'),
			},
			{
				id: 'PG-KM-TYPE-RAIL',
				label: 'Rail plafond',
				value: 'Rail plafond',
				nextStep: kitMotorisationPuissanceRail,
				description: makeDesc('rail'),
			},
		];

		fnSuccess(options);
	},
};

//description
// Rail de guidage plafond (chaîne ou courroie) avec chariot de traction

// Bras de liaison porte / chariot et accessoires de fixation complets

// Centrale de commande intégrée avec récepteur radio

// Télécommande(s) radio pour ouverture et fermeture à distance

// Système de déverrouillage manuel de secours (coupure de courant)

// Fins de course automatiques et détection d’obstacles pour la sécurité

// Notice de pose et de réglage fournie